/**
 * @generated SignedSource<<90bc0be0048df6d5aac7875f6b63cc95>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type photoEssayArticleArticle$data = {
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleLandingBannerArticle" | "globalCheckerContent">;
  readonly " $fragmentType": "photoEssayArticleArticle";
};
export type photoEssayArticleArticle$key = {
  readonly " $data"?: photoEssayArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"photoEssayArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "photoEssayArticleArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleLandingBannerArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "globalCheckerContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "f2551fccda0b00010de380e3d17ffbe0";

export default node;
